(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.innerWidth >= 1024 || document.location.pathname == '/') return console.log('window size is over 1024 or on home page');

    var mediaWrapper = document.querySelector('.product__media-wrapper');
    if (!mediaWrapper || !mediaWrapper.dataset.stickyMobile) return;

    var lastTop = null;

    function checkSticky() {
      var rect = mediaWrapper.getBoundingClientRect();
      if ((lastTop !== null && rect.top < lastTop && rect.top <= 0) || rect.top <= 0) {
        mediaWrapper.classList.add('is-stuck');
        // the mediaWrapper height as css variable
        document.documentElement.style.setProperty('--media-wrapper-height', mediaWrapper.offsetHeight + 'px');
      } else {
        mediaWrapper.classList.remove('is-stuck');
      }
      lastTop = rect.top;
    }

    window.addEventListener('scroll', checkSticky, { passive: true });
    window.addEventListener('load', checkSticky);
    window.addEventListener('DOMContentLoaded', checkSticky);
    checkSticky();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function adjustV2Spacing() {
      document.querySelectorAll('.hero-banner-v2').forEach(function (wrapper) {
        var box = wrapper.querySelector('.hero-banner-v2__text-box');
        if (!box) return;
        wrapper.style.marginBottom = box.offsetHeight / 2 + 'px';
      });
    }
    if (document.readyState === 'complete') {
      adjustV2Spacing();
    } else {
      window.addEventListener('load', adjustV2Spacing);
    }
    window.addEventListener('resize', adjustV2Spacing);
  })();

  } catch(e) { console.error(e); }
})();
})();
